// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"b4ffa6c9","240":"a4792c27","389":"8d0ff1f6","656":"7c193b29","993":"e4a578c5"}[chunkId] + ".chunk.js";
};